import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import Isvg from 'react-inlinesvg';
import { useDispatch } from 'react-redux';

import { PFE_ICONS } from 'constants/icons';
import LINKS from 'constants/links';
import { EMAIL_REGEX } from 'constants/logic';
import { bem } from 'helpers/class-name';
import { Form, Input, Button } from 'components/HookForm';
import Message from 'components/Message';
import { createErrorBanner } from 'components/Banner';
import { getDecagonChatPath } from 'helpers/link-generation';

import { loginFormMessages as messages, validationMessages } from './Auth.messages';
import './Auth.scss';

const { element } = bem('auth');

function Login(props) {
  const { handleSubmit } = props;
  const { pathname, search, state } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const error = state?.error;
    if (error === 'mfa_token_missing') {
      dispatch(createErrorBanner(messages.loginFailed));
    }
  }, [dispatch]);

  return (
    <div className={element('wrapper')}>
      <Isvg className={element('logo')} src={PFE_ICONS.logotype} />

      <Form onSubmit={handleSubmit} data-cypress="login-form">
        <Message message={messages.signIn} as="h1" className={element('header')} />

        <Input
          name="email"
          type="email"
          placeholder={messages.email}
          required
          pattern={{
            value: EMAIL_REGEX,
            message: validationMessages.invalidEmail,
          }}
          className={element('input', 'mb-r')}
          autoFocus
        />

        <Input
          name="password"
          type="password"
          placeholder={messages.password}
          required
          className={element('input', 'mb-r')}
        />
        <Message
          message={messages.legalText}
          as="p"
          className={element('legal-text')}
          values={{
            terms: text => (
              <a
                href={LINKS.termsOfUse.href}
                className={element('legal-text-link')}
                target="_blank"
                rel="noopener noreferrer">
                {text}
              </a>
            ),
            'privacy-policy': text => (
              <a
                href={LINKS.privacyPolicy.href}
                className={element('legal-text-link')}
                target="_blank"
                rel="noopener noreferrer">
                {text}
              </a>
            ),
          }}
        />
        <Message message={messages.logIn} as={Button} type={Button.TYPES.SUBMIT} className={element('submit')} />
      </Form>

      <div className={element('quick-link-container')}>
        <a href={LINKS.signUp.href} className={element('quick-link')}>
          <Message message={messages.noLogin} />
        </a>
        <Message message={messages.resetPassword} as={Link} to="/reset-password" className={element('quick-link')} />
        <Message
          message={messages.support}
          as={Link}
          to={getDecagonChatPath(pathname, search)}
          className={element('quick-link')}
        />
      </div>
    </div>
  );
}

Login.propTypes = {
  handleSubmit: PropTypes.func,
};

export default Login;
